/**
 *  <Desription of Service here>
 *
 * @export
 * @class HeroManager
 */
import * as Snap from 'snapsvg/dist/snap.svg.js'

export class HeroManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', '$animate', '$q', 'DataManager', 'ColorManager', 'AudioManager', 'UserAgentManager', '$rootScope', 'ProgressManager', 'TrackingManager', 'ModalManager'];
  public isZoomed: boolean = false
  public zoomedBodyPart: string = "";
  public svgContainer: any = undefined
  public svgElement: any
  public bodyPartsLoaded: number = 0
  public numBodyParts: number = 1
  public body: any
  public bodyPartUrls: any
  public bodyPartIconUrls: any
  public bodyGroup: any
  public baseSVG: any
  public groups: any
  public heroImageData: any
  public selectedPose: any = 'standing'
  public selectedGender: string = 'female'
  public heroDimensions: any = {}
  public bodyBasePath: string = ""
  public costumeChanges: any = []
  public useBucket: boolean = true;
  public useEyedropper: boolean = false;
  public activeTool: any = 'bucket'
  public randomColor: any = false

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any, public $animate: any, public $q: any, public DataManager: any, public ColorManager: any, public AudioManager: any, public UserAgentManager: any, public $rootScope: any, public ProgressManager: any, public TrackingManager: any, public ModalManager: any) {
    this.$log = $log.getInstance('HeroManager', false);
    this.$log.debug('constructor');

    Snap.plugin(function (Snap, Element, Paper, global) {
      Element.prototype.addTransform = function (t) {
        return this.transform(this.transform().localMatrix.toTransformString() + t);
      };
    });

    /*this.$rootScope.$on('progress:gender', (event, data) => {
      this.setGender(data.gender)
    })*/
    this.$rootScope.$on('progress:pose', (event, data) => {
      //this.setPose(data.pose)
    })

    if (this.ProgressManager.getGender() !== null) {
      if (this.selectedGender !== this.ProgressManager.getGender()) {
        this.selectedGender = this.ProgressManager.getGender()
      }
    }

  }

  public setPose(pose) {
    this.$log.debug("setPose", pose)
    this.selectedPose = pose
    this.ProgressManager.setPose(pose)
  }

  public setGender(gender) {
    this.$log.debug("setGender", gender)
    this.selectedGender = gender
    this.ProgressManager.setGender(gender)
    localStorage.removeItem('heromaker.PROGRESS_HERO_GOTG')
    this.init(this.svgContainer, this.svgElement, undefined)
  }

  public setBodyPart(bodypart) {
    this.$log.debug('setBodyPart', bodypart)

    let costumes = ['guardian1', 'guardian2', 'guardian3', 'guardian4', 'guardian5']

    let bp = bodypart.bodypart;
    let deviceType = this.UserAgentManager.getDevice();
    let costume
    if (bodypart.costumeName) {
      costume = bodypart.costumeName
    } else {
      costume = costumes[bodypart.costumeNumber - 1]
    }
    this.TrackingManager.trackCustome(this.selectedGender, this.selectedPose, costume, bp);

    if (this.selectedGender == '') {
      this.selectedGender = this.ProgressManager.getGender()
    }
    let basePath
    if (this.selectedGender.toLowerCase() === 'female') {
      basePath = 'poses/female/'
    } else {
      basePath = 'poses/male/'
    }
    var newbodypart = angular.copy(bodypart.image.slice(0, -4));
    let newbodypartPath = newbodypart.split('/')
    newbodypart += '.svg'

    this.loadBodyPartAsset(this.DataManager.config.settings.assetsPath + basePath + newbodypartPath[1] + '/fullBody.svg').then((svgFragment) => {
      this.$log.debug('loadBodypart', svgFragment)


        let bodyPartContainer = this.body['fullBody'].selectAll('#' + bp);
        if (bodyPartContainer[0].node.className.baseVal.indexOf(costume.toString()) == -1 ){
          let newBodyPart = svgFragment.selectAll('#' + bp);
          let color: any
          let needsColor =  false
          this.costumeChanges.push({'bodypart': bp, 'content': bodyPartContainer, 'type':'bodypartchange' });
          if (bodyPartContainer[0].node.classList){
            if (bodyPartContainer[0].node.classList.contains('paintbucket')) {
              color = bodyPartContainer[0].selectAll('.fill')[0].node.style.fill
              needsColor = true
              newBodyPart[0].node.classList.add(costume, 'paintbucket')
            } else {
              newBodyPart[0].node.classList.add(costume)
            }
          }

          if (bodyPartContainer[0].node.previousElementSibling){
            let prevEl = bodyPartContainer[0].node.previousElementSibling.id
            let el = this.body['fullBody'].selectAll('#' + prevEl);
            bodyPartContainer.remove()
            newBodyPart[0].click(event => { this.onPartSelected(event) })
            newBodyPart[0].insertAfter(el[0])
            if(needsColor){
              this.setCustomColor(newBodyPart[0].node.id, color);
            }
            /*if (this.randomColor === true){
              this.setRandomColor(newBodyPart);
            }*/
          }else{
            let nextEl = bodyPartContainer[0].node.nextElementSibling.id
            let el = this.body['fullBody'].selectAll('#' + nextEl);
            bodyPartContainer.remove()
            newBodyPart[0].click(event => { this.onPartSelected(event) })
            newBodyPart[0].insertBefore(el[0])
            if(needsColor){
              this.setCustomColor(newBodyPart[0].node.id, color);
            }
            /*if (this.randomColor === true){
              this.setRandomColor(newBodyPart);
            }*/
          }
        }
    })
  }

  public init(svgContainer, svgElement, hero) {
    this.$log.debug('init', svgContainer, svgElement)

    // Clear the svg container to avoid double character
    let heroContainerSVG = document.querySelector('.hero-image__container .svg')
    while (heroContainerSVG.firstChild) {
      heroContainerSVG.removeChild(heroContainerSVG.firstChild)
    }

    this.heroDimensions.width = 0;
    this.heroDimensions.height = 0;

    this.bodyPartsLoaded = 0

    if (this.svgContainer === undefined) {
      this.svgContainer = svgContainer
    }
    this.svgElement = svgElement
    this.baseSVG = Snap(svgElement)

    if (hero !== undefined) {
      document.querySelector(svgElement).innerHTML = hero
      this.bodyGroup = this.baseSVG
    } else {
      this.bodyGroup = this.baseSVG.group()
    }

    let basePath: string = '';
    let iconBasePath: string = '';

    if (this.selectedGender == '') {
      this.selectedGender = this.ProgressManager.getGender()
    }

    if (this.selectedGender.toLowerCase() === 'female') {
      basePath = 'poses/female/guardian-001/';
      iconBasePath = 'body-part-icons/female/';
    } else {
      basePath = 'poses/male/guardian-001/';
      iconBasePath = 'body-part-icons/male/';
    }

    this.bodyBasePath = basePath;

    this.body = {
      /*'head': undefined,
      'torso': undefined,
      'arm_upper_left': undefined,
      'arm_upper_right': undefined,
      'arm_lower_left': undefined,
      'arm_lower_right': undefined,
      'hand_left': undefined,
      'hand_right': undefined,
      'leg_upper_left': undefined,
      'leg_upper_right': undefined,
      'leg_lower_left': undefined,
      'leg_lower_right': undefined,
      'foot_left': undefined,
      'foot_right': undefined,*/
      'fullBody': undefined
    }

    this.bodyPartUrls = {
      'head': basePath + 'head.svg',
      'torso': basePath + 'torso.svg',
      'arm_upper_left': basePath + 'arm_upper_left.svg',
      'arm_upper_right': basePath + 'arm_upper_right.svg',
      'arm_lower_left': basePath + 'arm_lower_left.svg',
      'arm_lower_right': basePath + 'arm_lower_right.svg',
      'hand_left': basePath + 'hand_left.svg',
      'hand_right': basePath + 'hand_right.svg',
      'leg_upper_left': basePath + 'leg_upper_left.svg',
      'leg_upper_right': basePath + 'leg_upper_right.svg',
      'leg_lower_left': basePath + 'leg_lower_left.svg',
      'leg_lower_right': basePath + 'leg_lower_right.svg',
      'foot_left': basePath + 'foot_left.svg',
      'foot_right': basePath + 'foot_right.svg',
      'fullBody': basePath + 'fullBody.svg'
    }

    this.bodyPartIconUrls = {
      'head': iconBasePath + 'Head.svg',
      'torso': iconBasePath + 'Torso.svg',
      'arm_upper_left': iconBasePath + 'LupperArm.svg',
      'arm_lower_left': iconBasePath + 'LlowerArm.svg',
      'hand_left': iconBasePath + 'Lhand.svg',
      'leg_upper_left': iconBasePath + 'LupperLeg.svg',
      'leg_lower_left': iconBasePath + 'LlowerLeg.svg',
      'foot_left': iconBasePath + 'Lfoot.svg',
      'arm_upper_right': iconBasePath + 'RupperArm.svg',
      'arm_lower_right': iconBasePath + 'RlowerArm.svg',
      'hand_right': iconBasePath + 'Rhand.svg',
      'leg_upper_right': iconBasePath + 'RupperLeg.svg',
      'leg_lower_right': iconBasePath + 'RlowerLeg.svg',
      'foot_right': iconBasePath + 'Rfoot.svg'
    }

    if (hero === undefined) {
      this.loadBodyPart('fullBody');
    } else {
      this.connectSavedBodyPart('fullBody');
    }
  }

  public test(){
    var arr = []
    for(var i=0; i < 14; i++){
      arr.push(Math.floor(Math.random() * 5)+1)
    }
    return arr
  }

  public randomize() {
    let bodyParts = this.bodyPartUrls;
    let gender = this.ProgressManager.getGender();
    let currentHero = []
    let rand = this.test()
    //let costumeCount = this.DataManager.config.carousels.filter((value, index, array) => { return value.key === 'bodyParts-head-' + gender })[0].items.length;
    let costumeCount = this.DataManager.config.settings.costumes;
    $('#fullBody').children().each( (i,el:any) => {
      let elClass = el.className.baseVal
      if (elClass){
        currentHero.push(parseInt(elClass[elClass.length-1]))
      }
    });
    Object.keys(bodyParts).forEach( (key, i) => {
      if (key !== "fullBody") {
        let pathArray = bodyParts[key].split("/");
        // get a random number from 1 to the number of costumes available
        if (rand[i] === currentHero[i]){
          for (let i = rand.length; i; i--) {
            let j = Math.floor(Math.random() * i);
            [rand[i - 1], rand[j]] = [rand[j], rand[i - 1]];
          }
        }
        // create the image path changing the costume number with the random number
        let image = "../" + pathArray[2].slice(0, -1) + rand[i] + "/" + pathArray[3];
        let bodyPart = { "bodypart": key, "image": image, "costumeNumber": rand[i] };
        // **** RANDOM COLOR ONLY FOR TESTING PURPOSES ****
        //this.randomColor = true;
        // **** RANDOM COLOR ONLY FOR TESTING PURPOSES ****
        this.setBodyPart(bodyPart);
      }
    })
    this.ProgressManager.setHero(document.querySelector(this.svgElement).innerHTML)
    this.ModalManager.dismiss();
  }

  // **** RANDOM COLOR ONLY FOR TESTING PURPOSES ****
  /*public setRandomColor(bodypart) {
    let children = bodypart[0].node.children;
    let mainColors = ['blue', 'green', 'purple', 'red', 'yellow'];
    let colors = this.ColorManager.colors.variantColors;
    let randomColor, randomNum1, randomNum2;

    for (let i = 0; i < children.length; ++i) {
      if (this.svgHasClass(children[i], 'fill')) {
        randomNum1 = Math.floor(Math.random() * mainColors.length)
        randomNum2 = Math.floor(Math.random() * colors['red'].length)
        randomColor = colors[mainColors[randomNum1]][randomNum2];

        //randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);

        children[i].style.fill = randomColor;
      }
    }
  }*/
  // **** RANDOM COLOR ONLY FOR TESTING PURPOSES ****

  public connectSavedBodyPart(id) {
    this.$log.debug('connectSavedBodyPart', id, this.bodyGroup)
    this.body[id] = this.bodyGroup.select('#' + id)
    this.$log.debug(this.body[id])
    this.bodyPartsLoaded++
    if (this.bodyPartsLoaded >= this.numBodyParts) {
      this.onBodyPartsLoaded()
    }
  }

  public loadBodyPart(id) {
    this.$log.debug('loadBodyPart', id)
    this.loadBodyPartAsset(this.DataManager.config.settings.assetsPath + this.bodyPartUrls[id]).then((svgFragment) => {
      this.$log.debug('loadBodypart', id, svgFragment)
      this.bodyGroup.append(svgFragment);
      this.body[id] = this.bodyGroup.select('#' + id)
      this.bodyPartsLoaded++
      if (this.bodyPartsLoaded >= this.numBodyParts) {
        this.onBodyPartsLoaded()
      }
    });
  }

  public loadBodyPartAsset(url) {
    this.$log.debug('loadBodyPartAsset', url)
    return this.$q(function (resolve, reject) {
      Snap.load(url, resolve);
    });
  }

  /*
  public arrangeTorso() {
    console.log('arrangeTorso')

  }

  public rearrangeTorso() {
    console.log('rearrangeTorso')

  }
  */

  public onBodyPartsLoaded() {
    this.$log.debug('onBodyPartsLoaded', this.body)

    $('#head').click(event => { this.onPartSelected(event) })
    $('#torso').click(event => { this.onPartSelected(event) })

    $('#arm_upper_left').click(event => { this.onPartSelected(event) })
    $('#arm_lower_left').click(event => { this.onPartSelected(event) })
    $('#hand_left').click(event => { this.onPartSelected(event) })

    $('#arm_upper_right').click(event => { this.onPartSelected(event) })
    $('#arm_lower_right').click(event => { this.onPartSelected(event) })
    $('#hand_right').click(event => { this.onPartSelected(event) })

    $('#leg_upper_left').click(event => { this.onPartSelected(event) })
    $('#leg_lower_left').click(event => { this.onPartSelected(event) })
    $('#foot_left').click(event => { this.onPartSelected(event) })

    $('#leg_upper_right').click(event => { this.onPartSelected(event) })
    $('#leg_lower_right').click(event => { this.onPartSelected(event) })
    $('#foot_right').click(event => { this.onPartSelected(event) })


    // setup groups
    // the order here determines which groups overlay each other
    //this.groups = this.baseSVG.group(this.body.head.paper, this.body.torso.paper, this.body.arm_upper_right.paper, this.body.arm_lower_right.paper, this.body.hand_right.paper, this.body.arm_upper_left.paper, this.body.arm_lower_left.paper, this.body.hand_left.paper, this.body.leg_upper_right.paper, this.body.leg_lower_right.paper, this.body.foot_right.paper, this.body.leg_upper_left.paper, this.body.leg_lower_left.paper, this.body.foot_left.paper);
    this.groups = this.baseSVG.group(this.body.fullBody.paper);

    /*if (this.selectedGender.toLowerCase() === 'female') {
      this.groups.leftLeg = this.groups.group(this.body.leg_upper_left.paper, this.body.leg_lower_left.paper, this.body.foot_left.paper);

      this.groups.leftLeg.lowerLeg = this.groups.leftLeg.group(this.body.leg_lower_left.paper, this.body.foot_left.paper);

      this.groups.leftLeg.foot = this.groups.leftLeg.group(this.body.foot_left.paper);

      this.groups.rightLeg = this.groups.group(this.body.leg_upper_right.paper, this.body.leg_lower_right.paper, this.body.foot_right.paper);

      this.groups.rightLeg.lowerLeg = this.groups.rightLeg.group(this.body.leg_lower_right.paper, this.body.foot_right.paper);

      this.groups.upperBody = this.groups.group(this.body.head.paper, this.body.torso.paper, this.body.arm_upper_right.paper, this.body.arm_lower_right.paper, this.body.hand_right.paper, this.body.arm_upper_left.paper, this.body.arm_lower_left.paper, this.body.hand_left.paper);

      this.groups.upperBody.rightArm = this.groups.upperBody.group(this.body.arm_upper_right.paper, this.body.arm_lower_right.paper, this.body.hand_right.paper)

      this.groups.upperBody.rightArm.lowerArm = this.groups.upperBody.rightArm.group(this.body.hand_right.paper, this.body.arm_lower_right.paper)

      this.groups.upperBody.torso = this.groups.upperBody.group(this.body.torso.paper)

      this.groups.upperBody.head = this.groups.upperBody.group(this.body.head.paper)

      this.groups.upperBody.leftArm = this.groups.upperBody.group(this.body.arm_upper_left.paper, this.body.arm_lower_left.paper, this.body.hand_left.paper)

      this.groups.upperBody.leftArm.lowerArm = this.groups.upperBody.leftArm.group(this.body.hand_left.paper, this.body.arm_lower_left.paper)

    } else {
      /*this.groups.leftLeg = this.groups.group(this.body.leg_upper_left.paper, this.body.foot_left.paper, this.body.leg_lower_left.paper);

      this.groups.leftLeg.lowerLeg = this.groups.leftLeg.group(this.body.foot_left.paper, this.body.leg_lower_left.paper);

      // this.groups.leftLeg.foot = this.groups.leftLeg.group(this.body.foot_left.paper);

      this.groups.rightLeg = this.groups.group(this.body.leg_upper_right.paper, this.body.foot_right.paper, this.body.leg_lower_right.paper);

      this.groups.rightLeg.lowerLeg = this.groups.rightLeg.group(this.body.foot_right.paper, this.body.leg_lower_right.paper);

      this.groups.upperBody = this.groups.group(this.body.head.paper, this.body.torso.paper, this.body.arm_upper_right.paper, this.body.arm_lower_right.paper, this.body.hand_right.paper, this.body.arm_upper_left.paper, this.body.arm_lower_left.paper, this.body.hand_left.paper);

      this.groups.upperBody.leftArm = this.groups.upperBody.group(this.body.arm_upper_left.paper, this.body.arm_lower_left.paper, this.body.hand_left.paper)

      this.groups.upperBody.leftArm.lowerArm = this.groups.upperBody.leftArm.group(this.body.hand_left.paper, this.body.arm_lower_left.paper)

      this.groups.upperBody.torso = this.groups.upperBody.group(this.body.torso.paper)

      this.groups.upperBody.head = this.groups.upperBody.group(this.body.head.paper)

      this.groups.upperBody.rightArm = this.groups.upperBody.group(this.body.arm_upper_right.paper, this.body.arm_lower_right.paper, this.body.hand_right.paper)

      this.groups.upperBody.rightArm.lowerArm = this.groups.upperBody.rightArm.group(this.body.hand_right.paper, this.body.arm_lower_right.paper)*/

    //}
    // this.loopedRightArmAnimation();
    // this.loopedLeftArmAnimation();
    // this.loopedLowerLeftArmAnimation();
    // this.loopedLowerRightArmAnimation();
    // this.loopedRightLegAnimation();
    // this.loopedLowerLeftLegAnimation();
    // this.loopedLeftLegAnimation();
    // this.loopedLeftFootAnimation();
    // this.bringToLife();

    // this.setHeroImageData()

  }

  public bringToLife() {
    this.loopedAnimation();
  }

  public stopLife() {
    this.groups.upperBody.torso.stop();
  }

  public loopedAnimation() {
    this.groups.upperBody.torso.animate(
      {
        transform: 'scale(1,1.03)',
      }, 2000, () => {
        this.groups.upperBody.torso.animate({ transform: 'scale(1,1)' }, 2000, () => { this.loopedAnimation() })
      })
  }

  public loopedRightArmAnimation() {
    let bbox = this.groups.upperBody.rightArm.getBBox();
    this.groups.upperBody.rightArm.animate(
      { transform: "r-2," + (bbox.x + 20) + ',' + (bbox.y + 20) }
      , 1000, mina.easeinout, () => {
        this.groups.upperBody.rightArm.animate({ transform: "r0," + (bbox.x + 20) + ',' + (bbox.y + 20) }, 1000, mina.easeinout, () => { this.loopedRightArmAnimation() })
      })
  }

  public loopedLeftArmAnimation() {
    let bbox = this.groups.upperBody.leftArm.getBBox();
    this.groups.upperBody.leftArm.animate(
      { transform: "r2," + (bbox.x + 0) + ',' + (bbox.y + 0) }
      , 2000, mina.easeinout, () => {
        this.groups.upperBody.leftArm.animate({ transform: "r0," + (bbox.x + 0) + ',' + (bbox.y + 0) }, 2000, mina.easeinout, () => { this.loopedLeftArmAnimation() })
      })
  }
  public loopedLowerLeftArmAnimation() {
    let bbox = this.groups.upperBody.leftArm.lowerArm.getBBox();
    this.groups.upperBody.leftArm.lowerArm.animate(
      { transform: "r-15," + (bbox.x + 20) + ',' + (bbox.y + 20) }
      , 3000, mina.easeinout, () => {
        this.groups.upperBody.leftArm.lowerArm.animate({ transform: "r0," + (bbox.x + 20) + ',' + (bbox.y + 20) }, 3000, mina.easeinout, () => { this.loopedLowerLeftArmAnimation() })
      })
  }

  public loopedLowerRightArmAnimation() {
    let bbox = this.groups.upperBody.rightArm.lowerArm.getBBox();
    this.groups.upperBody.rightArm.lowerArm.animate(
      { transform: "r25," + (bbox.x + 20) + ',' + (bbox.y + 20) }
      , 4000, mina.easeinout, () => {
        this.groups.upperBody.rightArm.lowerArm.animate({ transform: "r0," + (bbox.x + 20) + ',' + (bbox.y + 20) }, 4000, mina.easeinout, () => { this.loopedLowerRightArmAnimation() })
      })
  }
  public loopedLeftLegAnimation() {
    let bbox = this.groups.lowerBody.leftLeg.getBBox();
    this.groups.lowerBody.leftLeg.animate(
      { transform: "r3," + (bbox.x + 20) + ',' + (bbox.y + 20) }
      , 1000, mina.easeinout, () => {
        this.groups.lowerBody.leftLeg.animate({ transform: "r0," + (bbox.x + 20) + ',' + (bbox.y + 20) }, 1000, mina.easeinout, () => { this.loopedLeftLegAnimation() })
      })
  }
  public loopedRightLegAnimation() {
    let bbox = this.groups.lowerBody.rightLeg.getBBox();
    this.groups.lowerBody.rightLeg.animate(
      { transform: "r-3," + (bbox.x + 20) + ',' + (bbox.y + 20) }
      , 1000, mina.easeinout, () => {
        this.groups.lowerBody.rightLeg.animate({ transform: "r0," + (bbox.x + 20) + ',' + (bbox.y + 20) }, 1000, mina.easeinout, () => { this.loopedRightLegAnimation() })
      })
  }
  public loopedLowerLeftLegAnimation() {
    let bbox = this.groups.lowerBody.leftLeg.lowerLeg.getBBox();
    this.groups.lowerBody.leftLeg.lowerLeg.animate(
      { transform: "r5," + (bbox.x + 20) + ',' + (bbox.y + 20) }
      , 2000, mina.easeinout, () => {
        this.groups.lowerBody.leftLeg.lowerLeg.animate({ transform: "r0," + (bbox.x + 20) + ',' + (bbox.y + 20) }, 2000, mina.easeinout, () => { this.loopedLowerLeftLegAnimation() })
      })
  }

  public loopedLeftFootAnimation() {
    let bbox = this.groups.lowerBody.leftLeg.foot.getBBox();
    this.groups.lowerBody.leftLeg.foot.animate(
      { transform: "r-5," + (bbox.x2 + 0) + ',' + (bbox.y + 0) }
      , 500, mina.easein, () => {
        this.groups.lowerBody.leftLeg.foot.animate({ transform: "r0," + (bbox.x2 + 0) + ',' + (bbox.y + 0) }, 500, mina.easein, () => { this.loopedLeftFootAnimation() })
      })
  }

  public onPartSelected(event) {
    this.$log.debug("onPartSelected", event.target)
    if (this.isZoomed) {
      if (this.useBucket) {
        let children = $(event.target).parent().children();
        let tempArray = [];
        let fillParts = [];
        for (let i = 0; i < children.length; ++i) {
          if (this.svgHasClass(children[i], 'fill')) {
            let bodypartId = children[i].id;
            let bodypartFill = children[i].style.fill;
            fillParts.push(children[i])
            $(event.target).parent().addClass('paintbucket')
            // create a temporary array of changes to store and use in the color changes array
            tempArray.push({ bodypartId, bodypartFill, 'type':'colorchange' });
          }
        }
        // fill the body parts but only save the progress when the last one is filled
        // the performance issue we were seeing was due to the datauri being generatedon every fill.
        for (let f = 0; f < fillParts.length; ++f) {
          this.fill(fillParts[f], (f === fillParts.length - 1))
        }
        //check to see if this change should be added to the color changes array
        this.addTocostumeChanges(tempArray);
      } else if (this.useEyedropper) {
        let color = $(event.target).css('fill');
        let hexColor = this.getHexFillColor(color);
        this.$rootScope.$apply(() => {
          this.ColorManager.setColor(color)
          this.ColorManager.selectedColorSet = 'colorPickerButton'
          this.ColorManager.selectColorSet('colorPickerButton')
        });
        // I'm adding a preview for the eyedropper color, then, I'm removing it from the DOM in the color picker.ts file
        let flashingDiv = document.getElementById('cursor-color-preview');
        let gameContainer = document.querySelectorAll('.hero-creator-container')[0].getBoundingClientRect()
        let x = event.clientX - gameContainer.left
        let y = event.clientY - gameContainer.top
        this.$animate.addClass(flashingDiv, 'clicked')
        flashingDiv.setAttribute('style', 'left:'+ x +'px; top:'+ y +'px;background-color:'+ color +';');
        this.$rootScope.$broadcast('eyedropperClicked');
      } else {
        if (this.svgHasClass(event.target, 'fill')) {
          this.fill(event.target);
        }
      }

    } else {
      this.$rootScope.$apply(() => {
        let bp = event.currentTarget.id.toString()
        this.zoomTo(bp)
        this.$rootScope.$broadcast('bodypartClicked', { bp: bp });
      });
    }
  }

  public addTocostumeChanges(tempArray) {
    let addChanges = false;
    let lastColored = this.costumeChanges[this.costumeChanges.length - 1];

    for (let i = 0; i < tempArray.length; ++i) {
      let bodypartId = tempArray[i].bodypartId;
      let bodypartFill = tempArray[i].bodypartFill;

      if (lastColored && lastColored.length !== undefined) {
        let hexColor = this.getHexFillColor(bodypartFill);
        if (hexColor !== this.getSelectedColor()) {
          addChanges = true;
        }
      } else {
        addChanges = true;
      }
    }

    if (addChanges) {
      this.costumeChanges.push({tempArray, 'type':'bucketcolor'});
    }
  }

  public fill(event, updateHeroData: boolean = true) {
    let bodypartId = event.id;
    let bodypartFill = event.style.fill;
    let hexFill = this.getHexFillColor(bodypartFill);

    if (hexFill !== this.getSelectedColor() && !this.useBucket) {
      this.costumeChanges.push({bodypartId, bodypartFill,'type':'colorchange' });
    }

    event.style.fill = this.getSelectedColor()

    if (updateHeroData) {
      // this.ProgressManager.setHero(document.querySelector(this.svgElement).innerHTML)
      // this.setHeroImageData()
    }
  }

  public setCustomColor(bodypart, color) {
    let parentBodyPart = this.body['fullBody'].selectAll('#' + bodypart);
    let children = parentBodyPart[0].node.children
    //let mainColors = ['blue', 'green', 'purple', 'red', 'yellow'];
    //let color = this.ColorManager.colors.variantColors;
    //let randomColor, randomNum1, randomNum2;

    for (let i = 0; i < children.length; ++i) {
      if (children[i].classList.contains('fill')) {
        //randomNum1 = Math.floor(Math.random() * mainColors.length)
        //randomNum2 = Math.floor(Math.random() * colors['red'].length)
        //randomColor = colors[mainColors[randomNum1]][randomNum2];

        //randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);

        children[i].style.fill = color;
      }
    }
  }

  public revertColorChanges(lastColorStep){
    let elId;
    if (lastColorStep.bodypartId !== undefined) {
      elId = lastColorStep.bodypartId.toString();
      document.getElementById(elId).style.fill = lastColorStep.bodypartFill.toString();
      $('#'+elId).parent().removeClass('paintbucket')
    } else {
      for (let i = 0; i < lastColorStep.length; ++i) {
        elId = lastColorStep[i].bodypartId.toString();
        document.getElementById(elId).style.fill = lastColorStep[i].bodypartFill.toString();
        $('#'+elId).parent().removeClass('paintbucket')
      }
    }
  }

  public revertBodyPartChanges(lastBPStep){
    let bodyPartContainer = this.body['fullBody'].selectAll('#' + lastBPStep.bodypart);
    $(bodyPartContainer).removeClass('paintbucket')
    let newBodyPart = lastBPStep.content
    if (bodyPartContainer[0].node.previousElementSibling){
      let prevEl = bodyPartContainer[0].node.previousElementSibling.id
      let el = this.body['fullBody'].selectAll('#' + prevEl);
      bodyPartContainer.remove()
      //newBodyPart[0].click(event => { this.onPartSelected(event) })
      newBodyPart[0].insertAfter(el[0])
    }else{
      let nextEl = bodyPartContainer[0].node.nextElementSibling.id
      let el = this.body['fullBody'].selectAll('#' + nextEl);
      bodyPartContainer.remove()
      //newBodyPart[0].click(event => { this.onPartSelected(event) })
      newBodyPart[0].insertBefore(el[0])
    }
  }

  public revertChanges() {
    if (this.costumeChanges.length > 0){
      let lastChange = this.costumeChanges.pop()
      if (lastChange.type === 'colorchange'){
        this.revertColorChanges(lastChange)
      }else if(lastChange.type === 'bucketcolor'){
        for(let i in lastChange.tempArray){
          this.revertColorChanges(lastChange.tempArray[i])
        }
      }else{
        this.revertBodyPartChanges(lastChange)
      }
    }else{
      this.zoomOut();
    }

    /*}else if (this.costumeChanges.length > 0 && this.costumeChanges.length == 0){
      let lastColorStep = this.costumeChanges.pop();
      this.revertcostumeChanges(lastColorStep)
    }else if (this.costumeChanges.length == 0 && this.costumeChanges.length > 0){
      let lastBPStep = this.costumeChanges.pop();
      this.revertBodyPartChanges(lastBPStep)*/

  }

  public undo() {
    let arrayLength = this.costumeChanges.length;
    for (let i = 0; i < arrayLength; i++) {
      this.revertChanges();
    }
    this.costumeChanges = [];
    this.zoomOut();
  }

  public svgHasClass(svg, className) {
    return new RegExp('(\\s|^)' + className + '(\\s|$)').test(svg.getAttribute('class'));
  }

  public getMatrix(scale = 1, x = 0, y = 0, rotate = 0) {
    let m = new Snap.Matrix();
    m.scale(scale)
    m.translate(x, y)
    m.rotate(rotate, 0, 0)
    return m;
  }

  public getSelectedColor() {
    // return '#' + Math.floor(Math.random() * 16777215).toString(16);
    return this.ColorManager.currentColor;
  }

  public componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  public getHexFillColor(rgb) {
    rgb = rgb.substr(4);
    rgb = rgb.substr(0, rgb.length - 1);
    let rgbArray = rgb.split(',');

    return "#" + this.componentToHex(parseInt(rgbArray[0])) + this.componentToHex(parseInt(rgbArray[1])) + this.componentToHex(parseInt(rgbArray[2]));
  }

  public toKebabCase(s: string): string {
    s.replace(/-([a-z])/g, function (m, w) {
      return w.toUpperCase();
    });
    return s;
  }

  public camelize(str) {
    let s: any = str.split('_')
    let n = []
    for (let i = 0; i < s.length; i++) {
      n.push(s[i].charAt(0).toUpperCase() + s[i].slice(1));
    }
    let f = n.join('')
    return f.charAt(0).toLowerCase() + f.slice(1)
  }

  public zoomTo(bodyPart = 'head') {
    this.activeTool = 'bucket'
    this.costumeChanges = [];
    this.$animate.addClass(document.querySelector('.creator-screen.active'), 'paintbucket')
    this.camelize(bodyPart)

    if (!this.isZoomed) {
      this.AudioManager.playFx('zoom')
      this.zoomedBodyPart = this.camelize(bodyPart);
      if (!this.svgContainer.hasClass(this.zoomedBodyPart)) {
        this.isZoomed = true;
        this.$animate.addClass(this.svgContainer, this.zoomedBodyPart)
        this.$animate.addClass(document.querySelector('.creator-screen.active'), 'podium-out')
        // this.stopLife();
      }
    }
  }

  public zoomOut() {
    this.$log.debug('zoomOut')
    if (this.isZoomed) {
      this.AudioManager.playFx('zoom')
      if (this.svgContainer.hasClass(this.zoomedBodyPart)) {
        this.$animate.removeClass(this.svgContainer, this.zoomedBodyPart)
        this.$animate.removeClass(document.querySelector('.creator-screen.active'), 'podium-out')
        this.isZoomed = false;
        this.zoomedBodyPart = "";
        this.ProgressManager.setHero(document.querySelector(this.svgElement).innerHTML)
      }
    }
    this.costumeChanges = [];
    this.useEyedropper = false
    this.useBucket = true
    this.activeTool = 'bucket'
    this.$animate.addClass(document.querySelector('.creator-screen.active'), 'paintbucket')
    this.$animate.removeClass(document.querySelector('.creator-screen.active'), 'paintbrush')
    this.$animate.removeClass(document.querySelector('.creator-screen.active'), 'eyedropper')
  }

  public setHeroImageData() {
    this.$log.debug('getHeroImageData')
    this.svgToCanvasToDataUri(this.baseSVG.node, (data) => {
      this.heroImageData = data
      this.$animate.removeClass(document.querySelector('.screen-container__loader'), 'visible')
      this.$animate.removeClass(document.querySelector('.screen-container__loader-overlay'), 'visible')
    })
  }

  public svgToCanvasToDataUri(svg, callback) {
    this.$log.debug('convertHeroImageToBase64PNG', svg)

    let isSafari = this.UserAgentManager.isSafari();
    let deviceType = this.UserAgentManager.getDevice();
    let svgString = new XMLSerializer().serializeToString(svg);
    let ratio   = window.devicePixelRatio || 1;

    let crop = [0, 0];
    let width = 582 + (582 * 0.30)
    let height = 900 + (900 * 0.30)

    /*if (this.selectedGender === "female") {
      crop = [200, 60];
      width = 190;
      height = 550;
    }*/

    this.heroDimensions.width = width;
    this.heroDimensions.height = height;

    let c: any = document.createElement('canvas')
    c.className = 'temp'
    let ctx = c.getContext && c.getContext('2d');
    /*ctx.mozImageSmoothingEnabled = false;
    ctx.webkitImageSmoothingEnabled = false;
    ctx.msImageSmoothingEnabled = false;
    ctx.imageSmoothingEnabled = false;*/

    c.width = 873
    c.height = 1179
    // this uses canvg to get around the IE tainted canvas issue while adding svg's to a canvas.
    // We have been working around the IE tainted canvas issue for a couple projects and this is the ONLY approach we have found
    // which lets us get around it without having an image proxy server, or a lamda function. See PPG-ME for the lamba.
    // https://github.com/gabelerner/canvg
    ctx.drawSvg(svgString, 10, -30);
    // document.querySelector('body').appendChild(c)

    let nc: any = document.createElement('canvas')
    nc.className = 'temp2'
    let nctx: any = nc.getContext && nc.getContext('2d');
    /*nctx.mozImageSmoothingEnabled = false;
    nctx.webkitImageSmoothingEnabled = false;
    nctx.msImageSmoothingEnabled = false;
    nctx.imageSmoothingEnabled = false;*/
    // document.querySelector('body').appendChild(nc)
    nctx.scale(ratio, ratio);
    nc.width = width;
    nc.height = height;

    if (isSafari || deviceType.model === 'iPad' || deviceType.model === 'iPhone') {
      nctx.drawImage(c, 0, 0)
    } else {
      nctx.drawImage(c, crop[0], crop[1], nc.width, nc.height, 0, 0, nc.width, nc.height)
      // document.querySelector('body').appendChild(nc)
    }
    callback(nc.toDataURL())
  }
};



/** WEBPACK FOOTER **
 ** ./src/common/services/hero-manager/hero-manager.ts
 **/